export default __webpack_public_path__ + "static/media/addCBtn.2d86010d.svg";